import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IStyledFontAwesomeSort {
  disabled?: boolean;
}

export const StyledFontAwesomeThatCanBeDisabled = styled(FontAwesomeIcon)<IStyledFontAwesomeSort>`
  color: ${(props) => props.disabled && props.theme.colors.darkGray};
`;
